import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import * as ProductLevels from 'self-service-api/constants/ProductLevels';
import { marketingPricing } from 'self-service-api/core/utilities/links';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import ProductInfoContainer from '../../components/common/ProductInfoContainer';
import CompareProFeatureTable from '../../components/feature-table/CompareProFeatureTable';
import { HUB_PRO_PLUS_UPGRADE_PAGE } from '../../constants/ErrorBoundaryNames';
import { SCREENS, UPGRADE_PAGES } from '../../constants/tracking/Locations';
import { isUngatedForUpgradePagePopularFeaturesSelector } from '../../selectors/GatingSelectors';
import ComparePlansLink from '../ComparePlansLink';
import { withErrorBoundary } from '../ErrorBoundary';
import { ProPlusSupportContent } from '../ProPlusSupportContent';
import UpgradeHeroBanner from '../UpgradeHeroBanner';
import PopularFeaturesPanel from '../popularFeaturesPanel/PopularFeaturesPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubProPlusUpgradePage = ({
  upgradePointApiName,
  upgradeConfig,
  purchaseMotions,
  handlePurchaseMotionButtonClick,
  upgradeSource
}) => {
  const isUngatedForUpgradePagePopularFeatures = useSelector(isUngatedForUpgradePagePopularFeaturesSelector);
  const productLevel = getProductLevelFromApiNameString(upgradePointApiName);
  useEffect(() => {
    const pageType = productLevel === ProductLevels.ENTERPRISE ? UPGRADE_PAGES.ENTERPRISE : UPGRADE_PAGES.PROFESSIONAL;
    getUsageTracker().setProperties({
      screen: SCREENS.UPGRADE_PAGE,
      subscreen: pageType
    });
    getUsageTracker().track('upgradesInteraction', {
      action: 'viewed upgrade page',
      upgradeSource,
      upgradeKey: upgradeConfig.upgradeKey,
      apiName: upgradePointApiName,
      pageType
    });
    // keep empty dependency array so not to repeat event and exposure log
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "pro-plus-upgrade-page",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "PRO_PLUS_UPGRADE_PAGE"
    }), /*#__PURE__*/_jsx(UpgradeHeroBanner, {
      upgradeConfig: upgradeConfig,
      upgradePointApiName: upgradePointApiName,
      purchaseMotions: purchaseMotions,
      handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick
    }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
      style: {
        margin: 'auto'
      },
      children: [/*#__PURE__*/_jsx(ComparePlansLink, {}), /*#__PURE__*/_jsx(ProPlusSupportContent, {}), productLevel === ProductLevels.PROFESSIONAL && isUngatedForUpgradePagePopularFeatures ? /*#__PURE__*/_jsx(PopularFeaturesPanel, {
        upgradeConfig: upgradeConfig,
        apiName: upgradePointApiName,
        productLevel: productLevel
      }) : null, /*#__PURE__*/_jsx(CompareProFeatureTable, {
        upgradePointApiName: upgradePointApiName,
        purchaseMotions: purchaseMotions,
        handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick,
        upgradeKey: upgradeConfig.upgradeKey,
        feature: upgradeConfig.feature
      })]
    })]
  });
};
export default withErrorBoundary(HubProPlusUpgradePage, {
  boundaryName: HUB_PRO_PLUS_UPGRADE_PAGE,
  redirectCallback: marketingPricing
});